"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shopping = exports.Shade = exports.Quantity = exports.Price = exports.Points = exports.Name = exports.ImageWrapper = exports.Details = exports.BubbleWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const BubbleWrapper = exports.BubbleWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.common.white,
  border: `2px solid ${theme.palette.grey[100]}`,
  borderRadius: theme.spacing(2),
  boxShadow: _mui.SHADOW_LEVEL3,
  display: 'flex',
  height: _constants.bubbleHeight,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
  pointerEvents: 'auto',
  position: 'relative',
  width: theme.spacing(64),
  userSelect: 'none'
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: theme.spacing(1, 0, 0, 1),
  flex: theme.spacing(0, 0, 16),
  marginRight: theme.spacing(2),
  overflow: 'hidden',
  position: 'relative'
}));
const Details = exports.Details = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flexStart',
  width: 216
});
const Name = exports.Name = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 700,
  overflow: 'hidden',
  paddingTop: theme.spacing(2),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%'
}));
const Shade = exports.Shade = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.caption.fontSize
}));
const Shopping = exports.Shopping = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  marginTop: 'auto'
});
const Quantity = exports.Quantity = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  flexGrow: 1,
  fontSize: theme.typography.caption.fontSize
}));
const Price = exports.Price = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 700,
  marginLeft: 'auto'
}));
const Points = exports.Points = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.primary.main,
  borderRadius: '50%',
  bottom: theme.spacing(2),
  color: theme.palette.primary.contrastText,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 'bold',
  height: theme.spacing(7),
  lineHeight: theme.spacing(7),
  position: 'absolute',
  right: theme.spacing(2),
  textAlign: 'center',
  width: theme.spacing(7)
}));
